import {
  Filter,
  FilterErrors,
  FilterKey,
  isStandardFilterArrayValue,
  Operator,
  StandardFilterValue,
} from 'search/SearchConstants';

// Keep in sync with benchling.search.interface.filters.annotation_bases_filter.MIN_ANNOTATION_BASES_LENGTH
export const MIN_ANNOTATION_BASES_LENGTH = 8;

const ANNOTATION_BASES_LENGTH_ERROR = `Annotation bases search requires at least ${MIN_ANNOTATION_BASES_LENGTH} characters.`;

function getAnnotationBasesTextValues(value: StandardFilterValue | undefined): Array<string> {
  if (value == null) {
    return [];
  }
  if (typeof value === 'string') {
    return [value];
  }
  if (isStandardFilterArrayValue(value)) {
    return value.filter((v): v is string => typeof v === 'string');
  }
  return [];
}

export default function validateAnnotationBasesFilters(filters: Array<Filter>): FilterErrors {
  return filters.map((filter) => {
    if (filter.key !== FilterKey.ANNOTATION_BASES) {
      return null;
    }
    if (filter.operator !== Operator.INCLUDES_TEXT && filter.operator !== Operator.EXCLUDES_TEXT) {
      return null;
    }
    for (const text of getAnnotationBasesTextValues(filter.value)) {
      if (text.length < MIN_ANNOTATION_BASES_LENGTH) {
        return ANNOTATION_BASES_LENGTH_ERROR;
      }
    }
    return null;
  });
}
